import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next-axiom/dist/webVitals/components.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/askpaul_web/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/assets/common/title_logo.png");
;
import(/* webpackMode: "eager", webpackExports: ["ChannelTabs"] */ "/var/www/askpaul_web/src/app/components/channelTabs/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/common/Register/RegisterModal.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/category/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/header.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/header1.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/search/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/askpaul_web/src/app/components/layout-widgets/setCookieFormServer/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/tabbar/index.tsx");
